import StateType from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  setProducts(state: StateType, products: any): void {
    state.products = products;
  },
  setTotal(state: StateType, total: number): void {
    state.total = total;
  },
};
